import type { ApiBlock } from '@/types';

export function getBlock<T extends ApiBlock<string, any>>(
  blocks: ApiBlock<string, any>[],
  type: string,
): T | undefined {
  return blocks.find(block => block.type === type) as T | undefined;
}
